import BillingsCargoTaxiUpdateStatusRequest, {
  BillingsCargoTaxiUpdateStatusRequestBody,
} from "./billings-cargo-taxi-update-status.request";

const createBody = (
  request: BillingsCargoTaxiUpdateStatusRequest,
): BillingsCargoTaxiUpdateStatusRequestBody => {
  return {
    status: request.status,
    comment: request.comment,
  };
};

const billingsCargoTaxiUpdateStatusRequestFactory = {
  createBody,
};

export default billingsCargoTaxiUpdateStatusRequestFactory;
